export enum EvaluationBy {
  PublicAdministration = 'Public administration',
  PublicResearchInstitute = 'Public research institute',
  Academia = 'Academia',
  PrivateFirmsConsultants = 'Private firms or consultants',
  CivilSocietyOrganisation = 'Civil society organisation',
  IntergovernmentalOrganisation = 'Intergovernmental organisation',
  Other = 'Other'
}
